import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '../../customer-billing-customer/customer-billing-customer.model';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { createMap } from '@fi-shared/utils/create-map';

@Component({
    selector: 'fi-customer-billing-customer-unit-view',
    templateUrl: './customer-billing-customer-unit-view.component.html',
    styleUrls: ['./customer-billing-customer-unit-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-unit-view' },
    standalone: false,
})
export class CustomerBillingCustomerUnitViewComponent implements OnInit {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() resellers: CustomerBillingOtherCustomerModel[];
    ContactPerson: BillingContactModel;
    BillingReference: BillingContactModel;
    EditTabs: EditTabsModel;
    private resellersMap: {
        [key: number]: CustomerBillingOtherCustomerModel;
    };

    constructor(private stateService: FiStateService) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.setInitialData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.customer.Name || this.customer.BusinessUnitName);
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    private setInitialData() {
        this.ContactPerson = this.customer.Contacts.sort(comparator((item) => item.IsDefault, true))[0];
        this.BillingReference = this.customer.InvoiceInfo.BillingReference[0] || new BillingContactModel();
        this.resellersMap = createMap(this.resellers, 'Id');
    }

    editCustomerUnitBilling() {
        this.stateService.go(FiStateNames.CustomerBilling.CustomerUnits.Edit, {
            UnitId: this.customer.BusinessUnitId,
            CustomerId: this.customer.CustomerId,
        });
    }

    getResellerName(resellerId: number): string {
        const reseller = this.resellersMap[resellerId];
        return reseller ? reseller.Name : this.customer.DefaultResellerName;
    }
}
